import { useQueries, useQuery } from '@tanstack/react-query'
import isNil from 'lodash/isNil'
import { useDocuments } from './useDocuments'

interface Props {
  filestoreId?: string
}

export const useCustomLogo = ({ filestoreId }: Props) => {
  const { getSignedUrl } = useDocuments()

  const { data: signedUrl, isLoading: isSignedUrlPending } = useQuery({
    queryKey: ['getLogoSignedUrl', filestoreId],
    queryFn: async () => {
      if (isNil(filestoreId)) return null
      const result = await getSignedUrl({
        filestoreId,
        fileName: 'logo.png',
      })
      if (!isNil(result) && typeof result === 'object' && 'notFound' in result) {
        return null
      }
      return result
    },
  })

  return {
    signedUrl,
    isSignedUrlPending,
  }
}

export const useCustomLogos = (filestoreIds: string[]) => {
  const { getSignedUrl } = useDocuments()

  return useQueries({
    queries: filestoreIds.map((filestoreId) => ({
      queryKey: ['getLogoSignedUrl', filestoreId],
      // Both hooks share this cache entry, so it must contain only the URL or null.
      queryFn: async (): Promise<string | null> => {
        const result = await getSignedUrl({ filestoreId, fileName: 'logo.png' })
        return typeof result === 'string' ? result : null
      },
      staleTime: Infinity,
    })),
  })
}
